(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DichiarazioneSearch', DichiarazioneSearch);

    DichiarazioneSearch.$inject = ['$resource'];

    function DichiarazioneSearch($resource) {
        var resourceUrl =  'api/_search/dichiaraziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
